// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/activities/chat.less
// module id = 392
// module chunks = 0